import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center" data-testid="logo-link">
          <img
            src="/logo.png"
            alt="ReadTheRoom"
            className="h-20 w-20 sm:h-24 sm:w-24 rounded-lg object-cover"
          />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollTo("manifesto")}
            className="font-body text-sm text-ink-light hover:text-terra transition-colors duration-300"
            data-testid="nav-our-story"
          >
            Our Story
          </button>
          <button
            onClick={() => scrollTo("features")}
            className="font-body text-sm text-ink-light hover:text-terra transition-colors duration-300"
            data-testid="nav-features"
          >
            Features
          </button>
          <Link
            to="/login"
            className="font-body text-sm text-ink-light hover:text-terra transition-colors duration-300"
          >
            Sign In
          </Link>
          <Link
            to="/register"
            className="bg-terra text-cream font-body text-sm font-semibold rounded-full px-6 py-2.5 hover:bg-orange-700 transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5"
          >
            Create Account
          </Link>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden text-ink p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-cream/95 backdrop-blur-md border-t border-cream-dark px-6 py-6 space-y-4"
          data-testid="mobile-menu"
        >
          <button
            onClick={() => scrollTo("manifesto")}
            className="block w-full text-left font-body text-ink-light hover:text-terra transition-colors"
          >
            Our Story
          </button>
          <button
            onClick={() => scrollTo("features")}
            className="block w-full text-left font-body text-ink-light hover:text-terra transition-colors"
          >
            Features
          </button>
          <Link
            to="/login"
            onClick={() => setMenuOpen(false)}
            className="block w-full text-left font-body text-ink-light hover:text-terra transition-colors"
          >
            Sign In
          </Link>
          <Link
            to="/register"
            onClick={() => setMenuOpen(false)}
            className="block w-full text-center bg-terra text-cream font-body font-semibold rounded-full px-6 py-3 mt-2"
          >
            Create Account
          </Link>
        </motion.div>
      )}
    </nav>
  );
}
